import { TableCellWithBadge } from "../../../data-model/tableCells";

/**
 * Sent to Client has only 2 display values: true or null.
 * - true: show "Yes" with success styling
 * - null / empty / falsy: show "Not Started" (same as current default)
 */
export const getSentToClientBadgeStyles = (
  value: string | null | undefined,
): TableCellWithBadge => {
  const isTrue = value != null && String(value).trim().toLowerCase() === "true";
  const isFalse =
    value != null && String(value).trim().toLowerCase() === "false";

  if (isTrue) {
    return {
      text: "Sent",
      color: "#005D49",
      bgColor: "#E6F3F0",
      hoverText: "Sent to Client",
    };
  }

  if (isFalse) {
    return {
      text: "Resubmit",
      color: "#CC0300",
      bgColor: "#FFE8E8",
      hoverText: "Resubmit",
    };
  }

  // null or any other value: show as before (default "Not Started")
  return {
    text: "Not Started",
    color: "#F5F5F5",
    bgColor: "#111111",
    hoverText: "Not Started",
  };
};
